export const escapeRegExp = (text: string): string => {
    let result = text.replace("+", "") 
    return result.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}